import type {ActionType} from 'constants/flow/flowTypes';
import {APP, ROUTER} from 'constants/actions';

import type {RouterInfoType} from './routerInfoType';

/* TODO reduce it to the simple {type: string, id: number, code: null | number} object */
export const initialState = {
    page: '',
    params: {
        id: '',
    },
    code: null,
};

/**
 * Page info reducer
 * @param {object} state Current state
 * @param {ActionType<RouterInfoType>} action Received action
 * @returns {RouterInfoType} state New state
 */
export default function routerInfo(
    state: RouterInfoType = initialState,
    action: ActionType<RouterInfoType>,
): RouterInfoType {
    switch (action.type) {
        /* TODO solution until the contact lenses do not use the new PDP code */
        case `${APP.GET_ROUTER_INFO}_PENDING`: {
            return {...initialState, prevPage: state.page};
        }
        case `${APP.GET_ROUTER_INFO}_FULFILLED`:
            return {
                ...state,
                page: action.payload.data.type,
                params: {id: action.payload.data.id},
                code: null,
            };
        case `${APP.GET_ROUTER_INFO}_REJECTED`:
            return {...state, code: action.payload.response.data.code};
        case ROUTER.SET: {
            return {...state, ...action.payload, prevPage: state.page, code: null};
        }
        default:
            return state;
    }
}
